export default "__VITE_ASSET__ZWQcSGy$__"